<template>
	<div class="full">
		<vxe-table :loading="loading" :data="data" height="90%" border :tooltip-config="{showAll:true}">
			<vxe-column type="seq" width="60"></vxe-column>
			<vxe-column field="parentordercode" title="父单编码"></vxe-column>
			<vxe-column field="ordercode" title="订单编码"></vxe-column>
			<vxe-column field="outboundcode" title="出库单编码"></vxe-column>
			<vxe-column field="collection_time" title="收款日期">
				<template #default="{ row }">
					<span>{{$systemMethods.timestampToDate(row.collection_time)}}</span>
				</template>
			</vxe-column>
			<vxe-column field="account" title="收款账户">
				<template #default="{ row }">
					<span>{{$systemMethods.getbankaccount(row.account)}}</span>
				</template>
			</vxe-column>
			<vxe-column field="payman" title="收款单位"></vxe-column>
			<vxe-column field="shop" title="收款店铺">
				<template #default="{ row }">
					<span>{{$systemMethods.getEmunValue('store',row.shop)}}</span>
				</template>
			</vxe-column>
			<vxe-column field="orderamount" title="收款金额"></vxe-column>
			<vxe-column field="needamount" title="应收款"></vxe-column>
		</vxe-table>
	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	export default {
		name: 'onlineIndex',
		props: {
			row: {
				type: Object,
				default: () => {
					return {}
				}
			},
			list: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				allAlign: null,
				data: [],
				warehouse:[],
				loading:false
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			if(this.row){
				this.getDetail()
			}else{
				this.data = []
			}
		},
		computed: {

		},

		methods: {
			getDetail() {
				this.loading = true
				this.$api.collection.getDetail(this.row.id).then((res) => {
					this.data = res
console.log(res)
					this.loading = false
				},()=>{
					this.loading = false
				})
			},

		},
		components: {

		}
	}
</script>
